import { Component } from '@angular/core';
@Component({
  selector: 'app-wellness-profile',
  templateUrl: './wellness-profile.component.html',
})
export class WellnessProfileComponent {}
